import api from '../../plugins/api';

// GET /api/crm/cars/stockImport/runs — последние прогоны импорта стока со сводкой.
const getStockImportRuns = (params) => {
  return api.get('/api/crm/cars/stockImport/runs', params);
};

export default getStockImportRuns;
